<template>
  <div class="layout--full-page" style="background: white !important;height: 100vh;">
  	<section class="bg-main w-full" style="position: fixed;top: 0;z-index: 101">
  		<div class="pt-4 md:pt-6 lg:pt-12 xl:pt-24"></div>
  		<div class="pt-4 md:pt-6 lg:pt-12   "></div>
      <div class="pt-4 md:pt-6 lg:pt-12"></div>
  		<div class="pt-4 md:pt-6 lg:mx-12 xl:mx-24">
  			<div class="mx-6 md:mx-8 lg:mx-12 xl:mx-24 vx-row justify-between items-end">
  				<div class="vx-col w-full md:w-1/2 flex justify-center md:justify-start items-end" style="z-index: 999;">
  					<img src="/zx.png" class="w-24 md:w-24 lg:w-24 xl:w-32" alt="" />
  					<h4 class="text-warning ml-2 pb-4"><strong>{{ $route.meta.pageTitle || '' }}</strong></h4>	
  				</div>
  				<div class="vx-col w-full md:w-1/2" style="z-index: 999;">
  					<ul class="flex justify-center md:justify-end pb-4">
  						<li class="mx-4">
  							<router-link to="/home">
  								<span class="text-warning">Home</span>
  							</router-link>
  						</li>
  						<li class="mx-4">
  							<router-link to="/about">
  								<span class="text-warning">Tentang ZX</span>
  							</router-link>
  						</li>
  						<li class="mx-4">
  							<router-link to="/sahabat-zx">
  								<span class="text-warning">Sahabat ZX</span>
  							</router-link>
  						</li>
  						<li class="mx-4">
  							<router-link to="/zxcare">
  								<span class="text-warning">ZX Care</span>
  							</router-link>
  						</li>
  					</ul>
  				</div>
  				
  			</div>
  		</div>
  		<div class="pb-6"></div>
  	</section>

  	<section class="md:mx-8 lg:mx-12 xl:mx-24 mt-12">
      <div>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="hidden md:block lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:block xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:hidden xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:hidden xl:block" ></vs-divider>
        <vs-divider color="#fff" class="block md:hidden lg:hidden xl:block" ></vs-divider>
      </div>
  		<div class="md:mx-8 lg:mx-12 xl:mx-24" id="content">
  			<div class="vx-row">
  				<div class="vx-col hidden md:block md:w-1/5">
  				<!-- sidevbar -->
  				<vs-button style="z-index: 100;" color="#f7f7f7" class="w-full text-primary mb-2" @click.prevent="$router.push(item.url)" v-for="(item, i) in menus" :key="i">
  					<span v-html="item.label"></span>
  				</vs-button>
  				<!-- / -->		
  				</div>
  				<div class="vx-col w-full md:w-4/5">
            <div class="mx-8">
              <router-view></router-view>          
            </div>
  					 
  				</div>
  			</div>
  			
  		</div>
  	</section>
    <br><br><br><br>
  </div>
</template>
<script>
export default {
  data: () => ({
    menus: [
      {
        label: 'Tentang Kami',
        url: '/about'
      },
      {
        label: 'Kebijakan Privasi',
        url: '/privacy-policy'
      },
      {
        label: 'Syarat & Ketentuan',
        url: '/terms-conditions'
      },
      {
        label: '<feather-icon icon="HomeIcon"></feather-icon><span class="ml-2">Home</span>',
        url: '/'
      }
    ],
    requirements: [
      'Perolehan dan Pengumpulan Data Pribadi Pengguna',
      'Penggunaan Data Pribadi',
      'Pengungkapan Data Pribadi Pengguna',
      '<i>Cookies</i>',
      'Pilihan Pengguna dan Transparansi',
      'Keamanan, Penyimpanan dan Penghapusan Data Pribadi Pengguna',
      'Akses dan Perbaikan Data Pribadi Pengguna atau Penarikan Kembali Persetujuan',
      'Pengaduan terkait Perlindungan Data Pribadi Pengguna',
      'Hubungi Kami',
      'Penyimpanan dan Penghapusan Informasi',
      'Pembaruan Kebijakan Privasi'
    ]
  })
}
</script>
<style lang="scss">
	.bg-main::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(4, 85, 50, 0.9);
		width: 100%;
		height: 100%;
	}
	.bg-main {
		position: relative;
		background-image: url('/assets/images/nature.jpg');
		background-repeat: no-repeat;
		background-size: cover;
	}
  body {
    background: white;
  }


</style>